/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Injectable} from '@angular/core';
import {FeatureToggleApi} from '../../api/feature-toggle/feature-toggle.api';
import {take} from 'rxjs/operators';
import {Observable, ReplaySubject} from 'rxjs';
import {FeatureToggleContract} from '../../api/feature-toggle/contracts/feature-toggle.contract';

@Injectable({
    providedIn: 'root'
})
export class FeatureToggleService {
    private loadedSubject = new ReplaySubject<void>(1);
    private disabledFeatureToggles: FeatureToggleContract[] = [];

    constructor(private featureToggleApi: FeatureToggleApi) {
        this.featureToggleApi.getAllFeatureToggles()
                .pipe(take(1))
                .subscribe((featureToggles) => {
                    this.disabledFeatureToggles = featureToggles.filter((toggle) => !toggle.value);
                    this.loadedSubject.next();
                    this.loadedSubject.complete();
                });
    }

    get onLoad(): Observable<void> {
        return this.loadedSubject.asObservable();
    }

    isEnabled(features: string[]): boolean {
        let isEnabled = true;

        if (this.disabledFeatureToggles.find((toggle) => features?.some((feature) => toggle.key === feature))) {
            isEnabled = false;
        }

        return isEnabled;
    }
}
